<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBDialog
			:dialog="dialog" 
			@agree="onClickAgree"
			@disagree="onClickDisagree"
		/>
		<GBModalVScrollable class="project-info"
			title="案件情報"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
		>
			<template v-slot:header v-if="!isModeReference">
				<div class="modal-header-project-info">
					<v-btn flat blue large color="white" v-on:click="onClickDone">完了</v-btn>
					<v-btn flat blue large color="white" v-on:click="deleteMe">削除</v-btn>
				</div>
			</template>
			<template v-if="value">
				<v-form ref="form-project-info">
				<v-layout wrap mx-2 pr-2>
					<v-flex xs2 mt-3 v-bind:class="classNameLabel">
						名前
					</v-flex>
					<v-flex xs10 mt-3 class="content-name">
						<template v-if="isModeReference">
							{{ value.project.name }}
						</template>
						<template v-else>
							<v-text-field
								v-model="value.project.name"
								maxlength="40"
								:rules="[rules.required, rules.name_length]"
								counter
							></v-text-field>
						</template>
					</v-flex>
					<v-flex xs2 mt-3 class="multi-line-label">
						分類
					</v-flex>
					<v-flex xs10 mt-3 class="content">
						<GBClasses
							:items="selectedClasses"
							:max_width="maxWidth"
							:all_show=true
						/>
						<v-btn
							flat
							fab
							class="btn-add-class"
							v-if="!isModeReference"
							v-on:click="onClickShowClassSelect"
						>
							<v-icon>add</v-icon>
						</v-btn>
					</v-flex>
					<v-flex xs2 mt-3 class="multi-line-label">
						色
					</v-flex>
					<v-flex xs10 mt-3 class="content">
						<GBColors
							:items="selectedColor"
							:max_width="maxWidth"
							:all_show=false
							:type="typeColor"
							:select_type="typeSelect.SINGLE"
						/>
						<v-btn
							flat
							fab
							class="btn-add-color"
							v-if="!isModeReference"
							v-on:click="onClickShowColorSelect"
						>
							<v-icon>color_lens</v-icon>
						</v-btn>
					</v-flex>

					<v-flex xs12 v-for="info in additionalInfo" v-bind:key="info.additional_info.code">
						<v-layout>
							<v-flex sm2 mt-3 v-bind:class="classNameLabel">{{ info.additional_info.name }}</v-flex>
							<v-flex sm10 mt-3 class="content">
								<template v-if="isModeReference">
									<template v-if="info.additional_info.isNumber">
										{{ info.additional_data.value
												? isNaN(Number(info.additional_data.value)) ? info.additional_data.value : Number(info.additional_data.value).toLocaleString()
												: info.additional_data.value }}
									</template>
									<template v-else-if="info.additional_info.isAddress">
										<a :href="urlSearchMap(info.additional_data.value)" target="_blank" rel="noopener noreferrer">{{ info.additional_data.value }}</a>
									</template>
									<template v-else>
										{{ info.additional_data.value }}
									</template>
								</template>
								<template v-else>
									<v-text-field
										v-model="info.additional_data.value"
										:maxlength="info.additional_info.max_length"
										:rules="info.additional_info.createAdditionalInfoRules()"
										counter
									></v-text-field>
								</template>
							</v-flex>
						</v-layout>
					</v-flex>

					<v-flex xs2 mt-3 d-flex align-start class="multi-line-label">
						備考
					</v-flex>
					<v-flex xs10 mt-3 class="content">
						<template  v-if="isModeReference">
							<nl2br tag="p" :text="value.project.remarks" />
						</template>
						<template v-else>
							<v-textarea
								v-model="value.project.remarks"
								outline
								maxlength="100"
								:rules="[rules.remarks_length]"
								counter
							></v-textarea>
						</template>
					</v-flex>
				</v-layout>
				</v-form>
			</template>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import GBClasses from './GBClasses';
import GBColors from './GBColors';
import GBDialog from './GBDialog';
import clonedeep from 'lodash/cloneDeep';
import Class from '../data/Class';
import Color from '../data/Color';
import {FORM_MODE, COLOR_SELECT_TYPE} from '../data/Const';
import Notification from '../classes/Notification';
import Util from '../classes/Util';

export default {
	name: 'GBRightPaneProjectInfo',
	props: [
		"value",
		"selected_class",
		"selected_color",
	],
	components: {
		GBRightPane,
		GBModalVScrollable,
		GBClasses,
		GBColors,
		GBDialog,
	},
	data: function() {
		return {
			rules: {
				required: v => !!v || '入力してください',
				name_length: v => (v || '').length <= 40,
				remarks_length: v => (v || '').length <= 100,
			},
			dialog: {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			},
			typeSelect: COLOR_SELECT_TYPE,
		};
	},
	methods: {
		onClose: function() {
			this.$emit('close');
		},
		deleteMe: function() {
			const agree = () => {
				this.dialog.display = false;
				this.dialog.agree = null;
				this.$store.dispatch('deleteMe', {
					project_code: this.value.project.code,
				}).then((res) => {
					if(res)
						this.$emit('update-dataset');
					else
						this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
				});
				this.onClose();
			};
			this.confirmationDialog('案件を削除しますが、よろしいでしょうか', agree);
		},
		onClickShowClassSelect: function() {
			this.$emit('show-class-select', clonedeep(this.selectedClasses));
		},
		onClickShowColorSelect: function() {
			this.$emit('show-color-select', {
				color: clonedeep(this.selectedColor),
				type: this.typeColor,
				select_type: this.typeSelect.SINGLE,
			});
		},
		onClickDone: function() {
			const form = this.$refs['form-project-info'];
			if (!form.validate())
				return;
			if (this.value.project.name === '')
				return ;

			if (this.selected_class)
				this.value.project.classes = this.selected_class.map(c => new Class({
					code: c.code,
					name: c.name,
					relation_type: Class.RELATION_TYPE.PROJECT,
					relation_code: this.value.project.code,
				}));
			if(this.selected_color)
				this.value.project.color_code = this.selected_color[0].code;
			
			this.value.project.is_updated = true;
			this.$store.dispatch('updateListProject', this.value.project).then((res) => {
				if (res) {
					this.$emit('update-dataset');
				} else {
					this.$store.commit('addNotification', Notification.error('更新対象が削除されています', 'notificationCreateData'));
				}
			});
			this.onClose();
		},
		confirmationDialog: function(text, agree) {
			this.dialog.title = '確認';
			this.dialog.text = text;
			this.dialog.disagree = () => {
				this.dialog.display = false;
			};
			this.dialog.agree = agree;
			this.dialog.display = true;
		},
		onClickDisagree: function() {
			if (this.dialog.disagree)
				this.dialog.disagree();
			return;
		},
		onClickAgree: function() {
			if (this.dialog.agree)
				this.dialog.agree();
			return;
		},
		urlSearchMap: function(value) {
			return Util.urlSearchGoogleMap(value);
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		isModeReference: function() {
			if(!this.value)
				return true;
			return this.value.mode == FORM_MODE.REFERENCE;
		},
		isModeEntry: function() {
			if(!this.value)
				return false;
			return this.value.mode == FORM_MODE.ENTRY;
		},
		selectedClasses: function() {
			if (this.selected_class)
				return this.selected_class;
			else
				return this.value.project.classes;
		},
		selectedColor: function() {
			if(this.selected_color) {
				return this.selected_color;
			} else {
				return [{ code: this.value.project.color_code }];
			}
		},
		classNameLabel: function() {
			if(!this.value)
				return ;
				
			if(this.isModeReference)
				return ['multi-line-label'];
			else
				return ['label'];
		},
		maxWidth: function() {
			let max_width = 224;
			if (this.isModeReference)
				max_width = 264;
			return max_width;
		},
		typeColor: function() {
			return Color.RELATION_TYPE.PROJECT;
		},
		additionalInfo: function() {
			if(!this.value)
				return [];

			const ret = [];
			this.$store.getters.additionalInfo.forEach(add => {
				const data = this.value.project.project_additional.filter(pa => {
					return pa.additional_id == add.code;
				});
				if (data.length > 0) {
					ret.push({
						additional_info : add,
						additional_data : data[0],
					});
				}
			});

			return ret;
		},
	},
	watch: {
		'value': function() {
			if (this.value !== undefined && this.value !== null)
				if (this.isModeEntry)
					this.$nextTick(() => {
						setTimeout(() => {
							this.$parent.$parent.$parent.$el.querySelector('.project-info .content-name input').select();
						}, 10);
					});
		},
	},
}
</script>
<style>
	.modal-window.project-info .row-group {
		height: 60px;
	}
	.modal-window.project-info .row {
		
	}
	.modal-window.project-info .label {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 16px;
	}
	.modal-window.project-info .multi-line-label {
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		font-size: 16px;
		padding-top: 1px;
	}
	.modal-window.project-info .content {
		display: flex;
		align-items: flex-start;
		font-size: 16px;
	}
	.modal-window.project-info .content-name {
		word-wrap: break-word;
		font-size: 16px;
	}
	.modal-window.project-info .modal-header-project-info {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.project-info .btn-add-class, .modal-window.project-info .btn-add-color {
		height: 24px;
		width: 24px;
		margin: 0px;
	}
</style>
